import React from 'react';
import styled from 'styled-components';

import { FONT } from '../../styles/color';

const Field = styled.input`
	width: 100%;
	height: 50px;
	border: 1px solid ${ FONT.deep01 };
	box-sizing: border-box;
	border-radius: 8px;
	font: normal 400 18px Pretendard Variable;
	color: ${ FONT.default };
	padding: 0 10px;

	&::placeholder {
		color: ${ FONT.deep01 };
	}

	&:focus {
		outline: none;
	}
`;


export default function TextField(props) {
  	return (
		<Field type={ props.type }
			name={ props.name }
			value={ props.value }
			placeholder={ props.$placeholder }
			onChange={ props.onChange }
		/>
  	);
}
